export type Category = {
  id: string;
  name: string;
  name_gr?: string;
  slug: string;
  subcategories: string[];
  subcategories_gr?: string[];
};

// This is the new category structure as defined in the database
export const categories: Category[] = [
  {
    id: "b902fc8a-10fa-47af-a505-86f893db9131",
    name: "Jewelry & Accessories",
    name_gr: "Κοσμήματα & Αξεσουάρ",
    slug: "jewelry-and-accessories",
    subcategories: ["Necklaces", "Bracelets", "Earrings", "Rings", "Bags and Purses", "Hair Accessories", "Others"],
    subcategories_gr: [
      "Κολιέ",
      "Βραχιόλια",
      "Σκουλαρίκια",
      "Δαχτυλίδια",
      "Τσάντες και Πορτοφόλια",
      "Αξεσουάρ Μαλλιών",
      "Άλλα",
    ],
  },
  {
    id: "8d95e9c6-6d9c-42c5-9e4c-079e68c66d90",
    name: "Clothing & Shoes",
    name_gr: "Ρούχα & Παπούτσια",
    slug: "clothing-and-shoes",
    subcategories: ["Women's Clothing", "Men's Clothing", "Shoes"],
    subcategories_gr: ["Γυναικεία Ρούχα", "Ανδρικά Ρούχα", "Παπούτσια"],
  },
  {
    id: "161d1c16-8b6f-4369-8c17-9cf65a115c0d",
    name: "Home & Living",
    name_gr: "Σπίτι & Διακόσμηση",
    slug: "home-and-living",
    subcategories: [
      "Home Décor",
      "Furniture",
      "Bedding",
      "Kitchen & Dining",
      "Storage & Organization",
      "Outdoor & Garden",
    ],
    subcategories_gr: [
      "Διακόσμηση Σπιτιού",
      "Έπιπλα",
      "Κλινοσκεπάσματα",
      "Κουζίνα & Τραπεζαρία",
      "Αποθήκευση & Οργάνωση",
      "Εξωτερικός Χώρος & Κήπος",
    ],
  },
  {
    id: "d32ba65f-c552-4d85-afe8-5894b04cab31",
    name: "Wedding & Party",
    name_gr: "Γάμος & Πάρτι",
    slug: "wedding-and-party",
    subcategories: [
      "Wedding Décor",
      "Bridal Accessories",
      "Invitations & Stationery",
      "Party Supplies",
      "Favors & Gifts",
    ],
    subcategories_gr: [
      "Διακόσμηση Γάμου",
      "Νυφικά Αξεσουάρ",
      "Προσκλήσεις & Χαρτικά",
      "Είδη Πάρτι",
      "Μπομπονιέρες & Δώρα",
    ],
  },
  {
    id: "3c1f6dbd-e2e1-41e7-b5a7-0ab6aafdca81",
    name: "Toys & Entertainment",
    name_gr: "Παιχνίδια & Ψυχαγωγία",
    slug: "toys-and-entertainment",
    subcategories: ["Dolls & Action Figures", "Games & Puzzles"],
    subcategories_gr: ["Κούκλες & Φιγούρες Δράσης", "Παιχνίδια & Παζλ"],
  },
  {
    id: "02429968-e8d0-4e7e-b47c-ee85e14449eb",
    name: "Art & Collectibles",
    name_gr: "Τέχνη & Συλλογές",
    slug: "art-and-collectibles",
    subcategories: ["Paintings", "Prints & Photography", "Pottery", "Textiles", "Woodcraft"],
    subcategories_gr: ["Πίνακες Ζωγραφικής", "Εκτυπώσεις & Φωτογραφία", "Κεραμική", "Υφάσματα", "Ξυλουργική"],
  },
  {
    id: "e5d87c34-c893-47db-af7a-25da48a059dc",
    name: "Beauty & Personal Care",
    name_gr: "Ομορφιά & Προσωπική Φροντίδα",
    slug: "beauty-and-personal-care",
    subcategories: ["Skincare", "Haircare", "Bath & Body", "Makeup", "Fragrances"],
    subcategories_gr: ["Φροντίδα Δέρματος", "Φροντίδα Μαλλιών", "Μπάνιο & Σώμα", "Μακιγιάζ", "Αρώματα"],
  },
  {
    id: "93d387d1-d36b-4fa8-a897-e61fc8070033",
    name: "Kids & Baby",
    name_gr: "Παιδιά & Μωρά",
    slug: "kids-and-baby",
    subcategories: ["Baby Clothing & Shoes", "Nursery Décor", "Toys", "Blankets & Bedding"],
    subcategories_gr: [
      "Βρεφικά Ρούχα & Παπούτσια",
      "Διακόσμηση Βρεφικού Δωματίου",
      "Παιχνίδια",
      "Κουβέρτες & Κλινοσκεπάσματα",
    ],
  },
];
